import { render, staticRenderFns } from "./Broaddetail.vue?vue&type=template&id=a7dbfb28"
import script from "./Broaddetail.vue?vue&type=script&lang=js"
export * from "./Broaddetail.vue?vue&type=script&lang=js"
import style0 from "./Broaddetail.vue?vue&type=style&index=0&id=a7dbfb28&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports